import { queryKeys } from '../../lib/queryKeys';
import type { RequestError } from '../../shared';
import { observableToPromise } from '../../shared/observableToPromise';
import { type AccountResponse, getAccount } from '../api';

import { useConditionalQuery } from './useAccountQuery';

export function useAccount(accountId: string) {
  return useConditionalQuery<AccountResponse | null, RequestError>(
    queryKeys.accounts.detail(accountId),
    ({ signal }) => observableToPromise(getAccount(accountId), signal),
    Boolean(accountId),
  );
}
